import { useUserTokenPl24 } from '@/core/domain/enterprise/Users/Users.hooks';
import { Button } from 'antd';
import { LinkOutlined } from '@ant-design/icons';

import React from 'react';

// import { Container } from './styles';

const ButtonPartsLink24: React.FC = () => {
  const { data, refetch } = useUserTokenPl24();

  if (!data?.token) {
    return null;
  }

  return (
    <Button
      type="link"
      size="large"
      href={`https://www.oic.net.br/integradorUltraCarOiC/index.aspx?token=${data.token}`}
      onClick={() => refetch()}
      target="_blank"
    >
      Acessar PartsLink24
      <LinkOutlined />
    </Button>
  );
};

export default ButtonPartsLink24;
